import { SurveyV2 } from '@act/shared/data-transfer-objects';
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { Control } from 'react-hook-form';
import type { SurveyFormData } from './types';

export interface CheckboxInputProps {
  control: Control<SurveyFormData>;
  options: SurveyV2.OptionDto[];
  isRequired: boolean;
}

const CheckboxInput = ({ options, isRequired }: CheckboxInputProps) => {
  return (
    <FormGroup>
      {options.map(option => {
        return (
          <FormControlLabel
            key={option.id}
            control={
              <Checkbox
                id={option.id.toString()}
                value={option.id.toString()}
              />
            }
            label={option.text}
            required={isRequired}
          />
        );
      })}
    </FormGroup>
  );
};

export default CheckboxInput;
